module.exports = __webpack_public_path__ + "img/9_16.c98ce82c.png";